import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "flex flex-col items-center" }

import { computed } from 'vue'
import { useTheme } from '../../../utils/useTheme'


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingState',
  props: {
    message: {},
    fullscreen: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

const theme = useTheme()
const isDark = computed(() => theme.isDark.value)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'flex items-center justify-center p-4',
      _ctx.fullscreen ? 'fixed inset-0 bg-white/80 dark:bg-black/80 z-50' : ''
    ]),
    role: "status",
    "aria-label": _ctx.message
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["w-8 h-8 border-4 rounded-full animate-spin", [
          _ctx.fullscreen ? 'w-12 h-12' : 'w-8 h-8',
          isDark.value ? 'border-blue-400 border-t-transparent' : 'border-blue-600 border-t-transparent'
        ]])
      }, null, 2),
      (_ctx.message)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass([
          'mt-3',
          isDark.value ? 'text-gray-300' : 'text-gray-600',
          _ctx.fullscreen ? 'text-lg' : 'text-sm'
        ])
          }, _toDisplayString(_ctx.message), 3))
        : _createCommentVNode("", true)
    ])
  ], 10, _hoisted_1))
}
}

})